module.exports = __webpack_public_path__ + "images/icons_v2/reorder-381b86ba.svg";